import { Select } from "shared/components";
import {
  CriteriaTargetType,
  recordsOptions,
  yearsOptions
} from "../../../constants";
import { SelectImportance } from "./SelectImportance";
import { ApplicantSettings, CoSignerSettings } from "../../../types";
import { FC } from "react";
import { LeastMostLabel } from "./LeastMostLabel";
import { SettingCard } from "../../../../../components/SettingCard";

type Props = {
  criteria?: CoSignerSettings | ApplicantSettings;
  onValueChange: (
    criteria: string,
    key: string,
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => void;
  applyCriteria: boolean;
  readOnly?: boolean;
};

export const HousingCourtCriteria: FC<Props> = ({
  criteria,
  onValueChange,
  applyCriteria,
  readOnly
}) => {
  if (!criteria) return null;

  const disabled = Boolean(!applyCriteria || readOnly);

  return (
    <SettingCard title="Housing court">
      <p className="mb-3 text-sm font-medium text-content-1000">
        Housing court records
        <span className="text-content-200">
          {" "}
          ({CriteriaTargetType.INDIVIDUAL})
        </span>
      </p>
      <div className="mb-4 flex items-center justify-between">
        <div className="flex gap-2">
          <Select
            id="records"
            options={recordsOptions}
            value={criteria.housing_court_records?.value}
            onChange={(e) => onValueChange("housing_court_records", "value", e)}
            isDisabled={disabled}
            searchable={false}
          />
          <LeastMostLabel most />
          <Select
            id="records_years"
            options={yearsOptions}
            value={criteria.housing_court_records?.housing_court_records_years}
            onChange={(e) =>
              onValueChange(
                "housing_court_records",
                "housing_court_records_years",
                e
              )
            }
            isDisabled={disabled}
            searchable={false}
          />
        </div>
        <SelectImportance
          importance={criteria.housing_court_records?.importance}
          onChange={(e) =>
            onValueChange("housing_court_records", "importance", e)
          }
          disabled={disabled}
        />
      </div>
    </SettingCard>
  );
};
